import { exportReport1 } from "@/shared/api";
import { ReportManagerTable, ReportTaxAccountantTable } from "@/entity/report";
import { ReportOneForm } from "@/features/report";
import { filterValidValuesToObject } from "@/shared/lib";
import { vars } from "@/shared/lib/theme.css";
import { ReportOneFormType } from "@/shared/model";
import { Button, Column, Row } from "@/shared/ui";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/(auth)/_layout/manage/report-manage-1")({
	component: ReportManageScreen,
	validateSearch: (search: Partial<ReportOneFormType>): Partial<ReportOneFormType> => {
		return filterValidValuesToObject<ReportOneFormType, ReportOneFormType>(search);
	}
});

function ReportManageScreen() {
	const search = useSearch({
		from: "/(auth)/_layout/manage/report-manage-1",
		select: (search) => search,
		strict: true
	});

	return (
		<Column fullWidth style={{ gap: vars.size[8] }}>
			<ReportOneForm />
			<Row
				fullWidth
				style={{
					justifyContent: "flex-start",
					alignItems: "center",
					gap: vars.size[8],

					padding: vars.size[4]
				}}
			>
				<Button
					color="third"
					onClick={() => {
						exportReport1({
							dateRangeValue: {
								from: search.dateFrom,
								to: search.dateTo
							},
							managerIds: search.managerIds
						});
					}}
				>
					{"다운로드"}
				</Button>
			</Row>
			<Suspense>
				<ReportManagerTable />
			</Suspense>
			<Suspense>
				<ReportTaxAccountantTable />
			</Suspense>
		</Column>
	);
}
